import React, { useState, useEffect, useContext } from "react";
import "./armatupc.css";
import axios from 'axios';
import ProductViewArmaTuPc from "./componentsArmaTuPc/ProductViewArmaTuPc";
import { DataContext } from "../Context";
import { MdArrowBackIos } from "react-icons/md";
import LoadinSkeletonArmaTuPc from "./loadingSkeletonArmaTuPc/LoadinSkeletonArmaTuPc";

import BasicDocument from "../../components/BasicDocument/BasicDocument";
import { Link } from "react-router-dom";
import { FaFilePdf } from "react-icons/fa";


function HomeArmaTuPc({ addToCart, deleteQty }) {


  const {
    setChangeRenderProductSelected,
    setListaProductos,
    CartItem,
    idProduct,
    totalPrice,
    errorDolarAPI
  } = useContext(DataContext);
  const [categoria, setCategoria] = useState([]);
  const [productos, setProductos] = useState([]);
  const [relacionProductoCategoria, setRelacionProductoCategoria] = useState([]);
  const [realacionMarcaProducto, setRelacionMarcaProducto] = useState([]);
  const [filtradoMarcaProducto, setFiltradoMarcaProducto] = useState([])
  const [categorySelected, setCategorySelected] = useState("");
  const [marca, setMarca] = useState([])
  const [isSort, setIsSort] = useState("");
  const [renderImage, setRenderImage] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const baseURLCategorias = "https://72jjtpdj.directus.app/items/categorias?limit=-1";
  const baseURLProductos = "https://72jjtpdj.directus.app/items/productos?limit=-1";
  const baseURLMarca = "https://72jjtpdj.directus.app/items/marcas";
  const baseURLRelacionProductoCategoria = "https://72jjtpdj.directus.app/items/productos_categorias?limit=-1";
  const baseURLRelacionMarcaProducto = "https://72jjtpdj.directus.app/items/productos_marcas?limit=-1";
  const baseImage = "https://72jjtpdj.directus.app/assets/";
  const { precioValue } = useContext(DataContext);
  const productExit = CartItem.find((item) => item.id === idProduct);
  const total = Intl.NumberFormat('de-DE').format(CartItem.reduce((precio, item) => precio + item.qty * item.precio, 0));

  React.useEffect(() => {
    axios.get(baseURLCategorias).then((response) => {
      setCategoria(response.data.data.filter(item => item.armatupc === true));
    });

    axios.get(baseURLProductos).then((response) => {
      setProductos(response.data.data);

    });

    axios.get(baseURLMarca).then((response) => {
      setMarca(response.data.data);
    });

    axios.get(baseURLRelacionMarcaProducto).then((response) => {
      setRelacionMarcaProducto(response.data.data);
    });

  }, []);

  useEffect(() => {

    if (productExit) {
      setListaProductos(productExit);
      setChangeRenderProductSelected(true)
    } else {
      setChangeRenderProductSelected(false)
    }

  }, [productExit])


  const getProduct = (id) => {
    axios.get(baseURLRelacionProductoCategoria).then((response) => {
      setRelacionProductoCategoria(response.data.data.filter(item => Number(item.categorias_id) === Number(id)));
    });
    setRenderImage(true)
  }

  function ScrollToTopOnMount() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return null;
}

  const getSelectedCategory = (id, sort) => {

    setCategorySelected(id);
    setIsSort(sort);
    setButtonClicked(false);
    setChangeRenderProductSelected(false)
  }

  const renderCPU = (idMarca) => {
    setButtonClicked(true)
    getProduct(categorySelected)
    let filtrado = realacionMarcaProducto.filter(item => item.marcas_id === idMarca)
    setFiltradoMarcaProducto(filtrado);
  }



  return (
    <>
        <ScrollToTopOnMount/>
      {/* <ScrollToTopOnMount /> */}
      <div className="armatupc_container">
        <div className="sidebar_container">
          <div className="container_items">
            <div className="item_container_header">
              <h4>Total: {errorDolarAPI ? "USD" : "AR$"} {total}</h4>
              {CartItem.length > 0 ? <Link to="/cotizacion"><button className="button_cotizacion">Cotización <FaFilePdf/></button></Link> : null}
            </div>
            {
              categoria.length === 0 && new Array(8).fill().map((item, index) => (
                <LoadinSkeletonArmaTuPc key={index} />
              ))
            }
            {categoria &&
              categoria.map((value) =>
              (
                <div key={value.id} className={categorySelected === value.id ? "item_container_selected" : "item_container"} onClick={() => [getProduct(value.id), getSelectedCategory(value.id, value.sort)]}>
                  <div className="flex_left_item_container">
                    <h4>{value.nombre}</h4>
                    <h5>{categorySelected === value.id ? "estas en este paso" : null}</h5>
                  </div>
                  <div className="flex_right_item_container">
                    {buttonClicked && categorySelected === value.id ? <MdArrowBackIos className="icon_armatupc" /> : null}
                  </div>
                </div>
              )
              )
            }
          </div>
        </div>

        <div className="select_container_elements">
          {
            renderImage ? null : <img className="image_inicial" src={baseImage + "67d4b669-3a2d-42ae-a60c-7b5c0b08c3bb.png"} alt="laconsola-armatupc" />
          }
          {/* {
            categoria && categoria.map((categoriaItem) => (
              relacionProductoCategoria.slice(0, 1).map((value) => {
                if (value.categorias_id === categoriaItem.id) {

                  return (
                    categorySelected === 4 ? null :
                      <div key={categoriaItem.id} className='item-container-product-no-incluir'>
                        <h3>No incluir {categoriaItem.nombre}</h3>
                      </div>
                  )
                }
              })
            ))
          } */}

          {
            <>
              {
                isSort === 1  || isSort === 3?
                  <>
                    {
                      buttonClicked ?
                        <>
                          {
                            CartItem && CartItem.map((productItem) => (
                              relacionProductoCategoria.map((productoCategoria) => {
                                if (productoCategoria.productos_id === productItem.id) {
                                  return (
                                    filtradoMarcaProducto.map((value) => {
                                      if (value.productos_id === productItem.id) {
                                        return (
                                          <ProductViewArmaTuPc
                                            categoryId={value.categorias_id}
                                            addToCart={addToCart}
                                            key={productItem.id}
                                            id={productItem.id}
                                            nombre={productItem.nombre}
                                            imagen={productItem.imagen}
                                            precio={productItem.precio}
                                            descuento={productItem.descuento}
                                            valueFinal={precioValue * productItem.precio}
                                            selected={true}
                                          />
                                        )
                                      }
                                    }
                                    )
                                  )
                                }
                                
                              })

                            ))
                          }
                          {
                            productos && productos.sort((a , b) => a.precio - b.precio).map((productItem) => (
                              
                              relacionProductoCategoria.map((productoCategoria) => {
                                if (productoCategoria.productos_id === productItem.id) {
                                      return (
                                        filtradoMarcaProducto.map((value) => {
                                          if (value.productos_id === productItem.id) {
                                            if (CartItem.find((item) => item.id === productItem.id)) {
                                              CartItem.map(itemCart => {
                                                return (
                                                  <ProductViewArmaTuPc
                                                    categoryId={value.categorias_id}
                                                    addToCart={addToCart}
                                                    deleteQty={deleteQty}
                                                    key={itemCart.id}
                                                    id={itemCart.id}
                                                    nombre={itemCart.nombre}
                                                    imagen={itemCart.imagen}
                                                    precio={itemCart.precio}
                                                    valueFinal={precioValue * itemCart.precio}
                                                    descuento={itemCart.descuento}
                                                    stock={productItem.stock}
                                                  />
                                                )
                                              })
                                            } else {
                                              return (
                                                <ProductViewArmaTuPc
                                                  categoryId={value.categorias_id}
                                                  addToCart={addToCart}
                                                  key={productItem.id}
                                                  id={productItem.id}
                                                  nombre={productItem.nombre}
                                                  imagen={productItem.imagen}
                                                  precio={productItem.precio}
                                                  valueFinal={precioValue * productItem.precio}
                                                  descuento={productItem.descuento}
                                                  stock={productItem.stock}
                                                />
                                              )
                                            }
          
                                          }
                                        }
                                        )
                                      )
                                }
                              })

                            ))
                          }
                        </>
                        :
                        <>
                         <div className="select_container_elements_marca">
                            {
                              categoria && categoria.map((categoriaItem) => (
                                relacionProductoCategoria.slice(0, 1).map((value) => {
                                  if (value.categorias_id === categoriaItem.id) {
                  
                                    return (
                                      
                                      <h2 key={categoriaItem.id}>Selecciona una marca para {categoriaItem.nombre}</h2>
                                    )
                                  }
                                })
                              ))
                            }
                           
                            <div className="flex_marca_container">
                              {
                                
                                marca.map(value => {
                                  return (
                                    <div key={value.id} className="marca_container" onClick={() => renderCPU(value.id)}>
                                      <img src={baseImage + value.imagen} alt={value.nombre} />
                                    </div>
                                  )
                                })

                              }
                            </div>
                          </div>
                        </>
                    }

                  </>
                  :
                  <>
                    {
                      CartItem && CartItem.map((productItem) => (
                        relacionProductoCategoria.map((value) => {
                          if (value.productos_id === productItem.id) {
                            return (
                              <ProductViewArmaTuPc
                                categoryId={value.categorias_id}
                                addToCart={addToCart}
                                key={productItem.id}
                                id={productItem.id}
                                nombre={productItem.nombre}
                                imagen={productItem.imagen}
                                precio={productItem.precio}
                                descuento={productItem.descuento}
                                valueFinal={precioValue * productItem.precio}
                                selected={true}
                                stock={productItem.stock}
                              />
                            )
                          }
                        }
                        )
                      ))
                    }
                    {
                      productos && productos.sort((a , b) => a.precio - b.precio).map((productItem) => (
                        relacionProductoCategoria.map((value) => {
                          if (value.productos_id === productItem.id) {
                            if (CartItem.find((item) => item.id === productItem.id)) {
                              CartItem.map(itemCart => {
                                return (
                                  <ProductViewArmaTuPc
                                    categoryId={value.categorias_id}
                                    addToCart={addToCart}
                                    deleteQty={deleteQty}
                                    key={itemCart.id}
                                    id={itemCart.id}
                                    nombre={itemCart.nombre}
                                    imagen={itemCart.imagen}
                                    precio={itemCart.precio}
                                    descuento={itemCart.descuento}
                                    stock={productItem.stock}
                                  />
                                )
                              })
                            } else {
                              return (
                                <ProductViewArmaTuPc
                                  categoryId={value.categorias_id}
                                  addToCart={addToCart}
                                  key={productItem.id}
                                  id={productItem.id}
                                  nombre={productItem.nombre}
                                  imagen={productItem.imagen}
                                  precio={productItem.precio}
                                  valueFinal={precioValue * productItem.precio}
                                  descuento={productItem.descuento}
                                  stock={productItem.stock}
                                />
                              )
                            }

                          }
                        }
                        )
                      ))
                    }
                  </>
              }
            </>
          }

        </div>

      </div>
    </>
  );

}

export default HomeArmaTuPc;
